var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9697 14.7803C12.2626 15.0732 12.7374 15.0732 13.0303 14.7803L16.7803 11.0303C17.0732 10.7374 17.0732 10.2626 16.7803 9.96967C16.4874 9.67678 16.0126 9.67678 15.7197 9.96967L13.25 12.4393V5.75C13.25 5.33579 12.9142 5 12.5 5C12.0858 5 11.75 5.33579 11.75 5.75V12.4393L9.28033 9.96967C8.98744 9.67678 8.51256 9.67678 8.21967 9.96967C7.92678 10.2626 7.92678 10.7374 8.21967 11.0303L11.9697 14.7803ZM8.25 17.0001C7.83579 17.0001 7.5 17.3359 7.5 17.7501C7.5 18.1643 7.83579 18.5001 8.25 18.5001H16.75C17.1642 18.5001 17.5 18.1643 17.5 17.7501C17.5 17.3359 17.1642 17.0001 16.75 17.0001H8.25Z",
    fill: "#0052CC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.f94a71774026c86275d8c8d79a0735e5.svg";
export { ForwardRef as ReactComponent };